export const AVATAR_PLACEHOLDER = '/r/templates/common/images/avatarPlaceholder.png';
export const NO_IMAGE_PLACEHOLDER = '/r/templates/common/images/noImagePlaceholder.png';
export const HUBBUB_LEADERBOARD_URL = '/hubbub/leaderboard';
